import { render, staticRenderFns } from "./wb-return-config.vue?vue&type=template&id=3c245694"
import script from "./wb-return-config.vue?vue&type=script&lang=js"
export * from "./wb-return-config.vue?vue&type=script&lang=js"
import style0 from "./wb-return-config.vue?vue&type=style&index=0&id=3c245694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports